import React from 'react';
import { Board } from './Board';
import { arithmeticExpression, expressionItem } from './arithemetic';
import { Options } from './Options';
import { SetNumbers} from './SetNumbers';

export class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      arithmeticExpression: new arithmeticExpression(props),
      expressionItems: [
        new expressionItem('(', 0),
        new expressionItem(')', 1),
        new expressionItem('x', 2),
        new expressionItem('/', 3),
        new expressionItem('+', 4),
        new expressionItem('-', 5),
        new expressionItem('0', 6),
        new expressionItem('0', 7),
        new expressionItem('0', 8),
        new expressionItem('0', 9),
        new expressionItem('0', 10),
        new expressionItem('0', 11),
        new expressionItem(' ', 12),
        new expressionItem(' ', 13),
      ],
      targetNumber: 0,
      calculatedTotal: 0,
      solution: '',
      calculatedLines: [],
      calculatedErrors: '',
      isOptions: false,
      largeNumberCount: 2,
      smallNumberCount: 4,
      isSetNumbers: false,
    };
  }

  componentDidMount() {
    this.state.arithmeticExpression.newGame();
    this.setStateFromArithmeticExpression();
  }

  handleCommandClick(parmText) {
    switch (parmText) {
      case 'New':
        if (this.state.calculatedTotal !== this.state.targetNumber) {
          if (window.confirm('Do you wish to start a new calculation ?') === false) {
            break;
          }
        }
        this.state.arithmeticExpression.newGame();
        this.setStateFromArithmeticExpression();
        break;
      case 'Clear':
        this.state.arithmeticExpression.clearFormula();
        this.setStateFromArithmeticExpression();
        break;
      case 'Undo':
        this.state.arithmeticExpression.removeItemFromFormula();
        this.setStateFromArithmeticExpression();
        break;
      case 'Options':
        this.setState({
          isOptions: true,
        });
        break;
      case 'Numbers':
        if (this.state.calculatedTotal !== this.state.targetNumber) {
          if (window.confirm('Do you wish to enter the numbers and target ?') === false) {
            break;
          }
        }
        this.setState({
          isSetNumbers: true,
        });
        break;
      case 'Solve':
        if (this.state.largeNumberCount + this.state.smallNumberCount > 6) {
          window.alert('Solution is not available for more than 6 numbers.');
          break;
        }
        if (window.confirm('Do you wish to see solution ?') === false) {
          break;
        }
        this.state.arithmeticExpression.solvePuzzle();
        this.setStateFromArithmeticExpression();
        break;
      default:
        break;
    }
  }

  setStateFromArithmeticExpression() {

    let expressionItems = this.state.arithmeticExpression.expressionItems;
    let calculatedTotal = this.state.arithmeticExpression.calculatedTotal;
    let solution = this.state.arithmeticExpression.solution;
    let calculatedLines = this.state.arithmeticExpression.calculatedLines;
    let largeNumberCount = this.state.arithmeticExpression.largeCount;
    let smallNumberCount = this.state.arithmeticExpression.smallCount;

    this.setState({
      expressionItems: expressionItems,
      targetNumber: this.state.arithmeticExpression.targetNumber,
      calculatedTotal: this.state.arithmeticExpression.calculatedTotal,
      solution: solution,
      calculatedLines: calculatedLines,
      calculatedErrors: calculatedTotal,
      largeNumberCount: largeNumberCount,
      smallNumberCount: smallNumberCount,
    });
  }

  handleSymbolClick(parmIndex) {
    this.state.arithmeticExpression.addItemToFormula(parmIndex);
    this.setStateFromArithmeticExpression();
  }

  handleCloseModalClick() {
    this.setState({ 
      isOptions: false,
      isSetNumbers: false 
    });
  };

  handleSaveModalClick(largeNumberCount, totalNumberCount) {

    this.state.arithmeticExpression.setLargeSmall(largeNumberCount, totalNumberCount - largeNumberCount);
    this.state.arithmeticExpression.changeNumbers();
    this.setStateFromArithmeticExpression();
    this.setState({ isOptions: false });
  };

  handleSetNumbersModalClick(numbers, targetNumber) {
    this.state.arithmeticExpression.setGame(numbers, targetNumber);
    this.setStateFromArithmeticExpression();
    this.setState({ isSetNumbers: false });
  };

  render() {
    // const expressionItems = this.state.arithmeticExpression.expressionItems;
    const expressionItems = this.state.expressionItems;
    const targetNumber = this.state.targetNumber;
    const calculatedTotal = this.state.calculatedTotal;
    const solution = this.state.solution;
    const calculatedLines = this.state.calculatedLines;
    const calculatedErrors = this.state.calculatedErrors;
    const isOptions = this.state.isOptions;
    const isSetNumbers = this.state.isSetNumbers;
    const largeNumberCount = this.state.largeNumberCount;
    const totalNumberCount = this.state.smallNumberCount + this.state.largeNumberCount;

    return (
      <div className="game">
        <Board
          expressionItems={expressionItems}
          targetNumber={targetNumber}
          calculatedTotal={calculatedTotal}
          solution={solution}
          calculatedLines={calculatedLines}
          calculatedErrors={calculatedErrors}
          onCommandClick={(parms) => this.handleCommandClick(parms)}
          onSymbolClick={(parms) => this.handleSymbolClick(parms)}
        />

        {this.state.isOptions ? (
          <Options
            largeNumberCount={largeNumberCount}
            totalNumberCount={totalNumberCount}
            onCloseClick={(parms) => this.handleCloseModalClick(parms)}
            onSaveClick={(parm1, parm2) => this.handleSaveModalClick(parm1, parm2)}
            closeModal={() => this.closeModal()}
            isOptions={isOptions}
          />
        ) : null}

        {this.state.isSetNumbers ? (
          <SetNumbers
            onCloseClick={(parms) => this.handleCloseModalClick(parms)}
            onAcceptClick={(parm1, parm2) => this.handleSetNumbersModalClick(parm1, parm2)}
            closeModal={() => this.closeModal()}
            isSetNumbers={isSetNumbers}
          />
        ) : null}

      </div>
    );
  }
}


